export default {
  data: function data() {
    return {
      // 可传参字段--start
      showLayer: false,
      //默认不显示弹层
      extraClass: '',
      //外部传入的面板样式

      type: 'dialog',
      //类型有toast、dialog两种

      showMask: false,
      //是否显示背景蒙版
      canMaskCloseDialog: true,
      //点击蒙版是否可以关掉弹窗

      animateType: 1,
      //动画方式， 1/2
      animateClass: '',
      //动画样式
      showPanel: false,
      //默认不显示内容层

      extraCloseClass: '',
      //外部传入的关闭按钮样式
      showClose: false,
      //默认显示关闭按钮

      extraHeaderClass: '',
      //外部传入的header样式
      showHeader: true,
      //默认显示header
      hasBottomLine: false,
      //是否有底线

      extraBodyClass: '',
      //外部传入的body样式
      showBody: true,
      //默认显示body

      extraFooterClass: '',
      //外部传入的footer样式
      showFooter: true,
      //footer默认不显示

      showToastBox: false,
      //是否显示toast
      showToastTime: 1500,
      //toast显示时间，默认1.5s

      isShowDialog: false,
      //是否显示弹窗
      isShowToast: false,
      //是否显示toast
      isCloseDialog: false,
      //是否关闭弹窗

      noMove: true,
      //是否不允许滑动
      noClose: false,
      //设置关闭弹窗
      innerScroll: false,
      //是否可内部滚动

      defaultAnimateTime: 300,
      // 动画时长
      // 可传参字段--end

      // 组件内部使用，不作为外部传参字段--start
      st: '',
      //缓存setTimeout函数,不作为可传参值
      scrollTop: 0 // 滚动高度
      // 组件内部使用，不作为外部传参字段--end
    };
  },

  props: ['layerData'],
  watch: {
    layerData: function layerData(obj) {
      Object.assign(this, obj);
      if (obj.isShowDialog) {
        this.showDialog();
      }
      if (obj.isShowToast) {
        this.showToast();
      }
      if (obj.isCloseDialog) {
        this.closeDialog();
      }
    }
  },
  methods: {
    noMoveFn: function noMoveFn(e) {
      e.preventDefault();
    },
    addListenMove: function addListenMove() {
      document.addEventListener('touchmove', this.noMoveFn, {
        passive: false
      });
    },
    removeListenMove: function removeListenMove() {
      document.removeEventListener('touchmove', this.noMoveFn, {
        passive: false
      });
    },
    setScroll: function setScroll() {
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      this.scrollTop = scrollTop;
      setTimeout(function () {
        document.querySelector('body').setAttribute('style', 'overflow:hidden;height:100vh;');
      }, 100);
    },
    resetScroll: function resetScroll() {
      document.querySelector('body').setAttribute('style', '');
      document.body.scrollTop = this.scrollTop;
      document.documentElement.scrollTop = this.scrollTop;
    },
    //显示弹窗
    showDialog: function showDialog() {
      var _this = this;
      clearTimeout(this.st);
      this.noMove && this.addListenMove();
      this.innerScroll && this.setScroll();
      this.showLayer = true;
      this.showPanel = true;
      this.$emit('diaLogStatus', true);
      setTimeout(function () {
        _this.animateClass = 'show' + _this.animateType;
        _this.showMask = true;
      }, 16);
    },
    //关闭弹窗
    closeDialog: function closeDialog(type) {
      var _this2 = this;
      if (this.noClose) {
        return false;
      }
      if (!this.canMaskCloseDialog && type === 'maksClose') {
        return false;
      }
      this.showMask = false;
      this.animateClass = 'hide' + this.animateType;
      this.noMove && this.removeListenMove();
      this.innerScroll && this.resetScroll();
      this.$emit('diaLogStatus', false);
      this.st = setTimeout(function () {
        _this2.showLayer = false;
        _this2.showPanel = false;
        _this2.resetDialog();
      }, this.defaultAnimateTime);
    },
    //显示toast
    showToast: function showToast() {
      var _this3 = this;
      clearTimeout(this.st);
      this.showToastBox = true;
      setTimeout(function () {
        _this3.showToastBox = false;
      }, this.showToastTime);
      setTimeout(function () {
        _this3.resetToast();
      }, this.showToastTime + this.defaultAnimateTime);
    },
    //重置弹窗数据
    resetDialog: function resetDialog() {
      this.animateType = 1;
      this.animateClass = '';
      this.showPanel = false;
      this.extraHeaderClass = '';
      this.showHeader = true;
      this.hasBottomLine = false;
      this.extraBodyClass = '';
      this.showBody = true;
      this.extraFooterClas = '';
      this.showFooter = true;
      this.isShowDialog = false;
      this.canMaskCloseDialog = true;
    },
    //重置toast数据
    resetToast: function resetToast() {
      this.showToastTime = 1500;
      this.isShowToast = false;
    }
  },
  mounted: function mounted() {}
};